import React from "react";
import { withApollo } from '@apollo/client/react/hoc';
import { compose } from "modules/core";
import RewardSystemRedeemView from "../components/reward-system-redeem-view";
import { REWARD_REDEEM } from "../graphql/rewardSubscription.gql";
import { withRedeemPoint } from "../graphql/rewardOperations";
import { getIntFromString } from "modules/look";
import { message } from "antd";

const RewardSystemRedeemContainer = (props) => {
  const { client, rewardPermission, redeemPoints } = props;
  const [rewardList, setRewardList] = React.useState([]);
  const [totalPoints, setTotalPoints] = React.useState(0)
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    if (rewardPermission && rewardPermission.reward_redeem)
      getRewardData();
    else if (rewardPermission && rewardPermission.reward_redeem === false)
      setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rewardPermission]);
  const getRewardData = async (endCursor) => {
    try {
      const { data } = await client.query({
        query: REWARD_REDEEM,
        fetchPolicy: 'network-only',
        variables: { endCursor: endCursor },
      });
      if (data) {
        const allActivities = data.rewardList.map(ele => ({ id: ele.reward.id, title: ele.reward.name, pointsNeeded: ele.reward.pointsRequired, status: ele.status }))
        setTotalPoints(data?.totalRewardPoints);
        setRewardList(allActivities)
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching reward history:", error);
      setLoading(false);
    }
  }

  const redeemReward = async (rewardId, pointsRedeemed) => {
    try {
      setLoading(true)
      let response = await redeemPoints({
        userId: getIntFromString(props.me.id),
        orgId: getIntFromString(props.me.employee.organizationSet.edges[0].node.id),
        pointsRedeemed: Number(pointsRedeemed),
        rewardId: getIntFromString(rewardId)
      });
      if (response.redeemPoint.id) {
        getRewardData()
        message.success("Reward redeemed! Please check the mail.")
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.error("reward-system-redeem-container -> redeemReward", error)
      setLoading(false)
      message.error("Can-not perform this action")
    }
  }

  return (
    <RewardSystemRedeemView
      loading={loading}
      permission={rewardPermission?.reward_redeem}
      totalPoints={totalPoints}
      rewardList={rewardList}
      redeemReward={redeemReward}
      {...props}
    />
  );
}

export default compose(withApollo, withRedeemPoint)(RewardSystemRedeemContainer);
